import React from 'react';
import { PageModelLayout } from 'src/components/molecules/PageModelLayout';
import { LTFilterBar } from 'src/features/LT/components/organisms/LTFilterBar';
import { LTKeyMetrics } from 'src/features/LT/components/organisms/LTKeyMetrics';
import { LongTermEffects } from 'src/features/LT/components/templates/LongTermEffects';

export const LongTermEffectsPage: React.FC = () => {
  return (
    <PageModelLayout
      filterBar={<LTFilterBar />}
      keyMetrics={<LTKeyMetrics />}
      pageTitle="Long Term Effect">
      <LongTermEffects />
    </PageModelLayout>
  );
};
